import { vuexOidcCreateStoreModule } from 'vuex-oidc'
import { oidcSettings } from '../../config/oidc'
import axios from "axios";


export default vuexOidcCreateStoreModule(
    oidcSettings,
    {
        namespaced: true,
        dispatchEventsOnWindow: true,
    },
    {
        userLoaded: (user) => {
          if (process.env.NODE_ENV === 'development') {
                console.log('OIDC user is loaded')
            }
            axios.defaults.headers.common['Authorization'] = 'Bearer ' + user.access_token
        },
        userUnloaded: () => {
          if (process.env.NODE_ENV === 'development') {
                console.log('OIDC user is unloaded')
            }
            axios.defaults.headers.common['Authorization'] = undefined
        },
        accessTokenExpiring: () => {
          if (process.env.NODE_ENV === 'development') {
                console.log('Access token will expire')
            }
        },
        accessTokenExpired: () => {
          if (process.env.NODE_ENV === 'development') {
                console.log('Access token did expire')
            }
        },
        silentRenewError: () => {
          if (process.env.NODE_ENV === 'development') {
                console.log('OIDC user is unloaded')
            }
        },
        userSignedOut: () => {
          if (process.env.NODE_ENV === 'development') {
                console.log('OIDC user is signed out')
            }
        }
    }
)
